<template>
    <div class="row row-filters">
        <div class="col-sm-12">
            <button class="btn btn-xs btn-block" style="margin-bottom:10px;" @click="resetFilters">Reset Filters</button>
        </div>
        <div class="col-sm-12" v-if="userCanVet() && !hideVetting">
            <div class="vetting_filters">
                <strong>Vetting Filters</strong>
                <div>
                    <div class="input-checkbox input-checkbox--switch input-checkbox--switch-small">
                        <input id="checkbox-only-vettable" type="checkbox" name="checkbox-only-vettable" v-model="pending_filters.vettableOnly" />
                        <label for="checkbox-only-vettable"></label>
                    </div>
                    <span>Only Vettable Records</span>
                </div>
                <div>
                    <div class="input-checkbox input-checkbox--switch input-checkbox--switch-small">
                        <input id="checkbox-only-unvetted" type="checkbox" name="checkbox-only-unvetted" v-model="pending_filters.pendingOnly" />
                        <label for="checkbox-only-unvetted"></label>
                    </div>
                    <span>Only Pending Records</span>
                </div>
                <div>
                    <div class="input-checkbox input-checkbox--switch input-checkbox--switch-small">
                        <input id="checkbox-only-outliers" type="checkbox" name="checkbox-only-outliers" v-model="pending_filters.outliersOnly" />
                        <label for="checkbox-only-outliers"></label>
                    </div>
                    <span>Only Outlier Records</span>
                </div>
            </div>
        </div>
        <div class="col-md-6 col-sm-12 col-filter-taxon" v-if="!hideTaxon">
            <label>Taxon</label>
            <v-select label="common_name" :options="taxa"  @search="searchTaxa" v-model="pending_filters.selectedTaxons" multiple :filterable="false">
                <template slot="no-options">
                    Search for Taxa
                </template>
                <template slot="option" slot-scope="taxon">
                    <span class="notranslate" translate="no" v-if="taxon.common_name">{{ taxon.common_name }}</span>
                    <br v-if="taxon.common_name" />
                    <small class="notranslate" translate="no" v-if="taxon.scientific_name">{{ taxon.scientific_name }}</small>
                </template>
            </v-select>
        </div>
        <div class="col-md-6 col-sm-12 col-filter-location" v-if="!hideLocation">
            <label>Location</label>
            <v-select label="display_name" :options="locations"  @search="searchLocations" v-model="pending_filters.selectedLocations" multiple :filterable="false">
                <template slot="no-options">
                    Search for Location
                </template>
                <template slot="option" slot-scope="location" class="notranslate" translate="no">
                    {{ location.display_name }}
                    <small v-if="!location.display_name">{{ location.name }}</small>
                    <br v-if="location.type_data.name == 'County'" />
                    <small v-if="location.type_data.name == 'County'">{{ location.type_data.name }}</small>
                </template>
            </v-select>
        </div>
        <div class="col-md-6 col-sm-12 col-filter-status" v-if="!hideStatus">
            <label>Status</label>
            <v-select label="name" :disabled="pending_filters.pendingOnly" :options="statuses" v-model="pending_filters.selectedStatuses" multiple></v-select>
            <div v-if="!hideHighQualityOnly">
                <div class="input-checkbox input-checkbox--switch input-checkbox--switch-small">
                    <input id="checkbox-switch-excludeHQ" type="checkbox" name="checkbox-switch-excludeHQ" v-model="pending_filters.highQualityOnly" />
                    <label for="checkbox-switch-excludeHQ"></label>
                </div>
                <span>High Quality Only <i class="fa fa-info-circle" data-tooltip-wrap data-tooltip='Includes only records that are more likely to be identified correctly or that can be verified. See FAQ for details.'></i></span>
            </div>
            <div v-if="!hideIncludeDeclined">
                <div class="input-checkbox input-checkbox--switch input-checkbox--switch-small">
                    <input id="checkbox-switch-includeDeclined" type="checkbox" name="checkbox-switch-includeDeclined" v-model="pending_filters.includeDeclined" />
                    <label for="checkbox-switch-includeDeclined"></label>
                </div>
                <span>Include Declined Records</span>
            </div>
        </div>
        <div class="col-md-6 col-sm-12 col-filter-record-type" v-if="!hideRecordType">
            <label>Record Type</label>
            <v-select label="name" :options="recordTypes" v-model="pending_filters.selectedRecordTypes" multiple></v-select>
        </div>
        <div class="col-md-6 col-sm-12 col-filter-id" v-if="!hideID">
            <label>Odonata Central Record Number (OC#) <i class="fa fa-info-circle" data-tooltip-wrap data-tooltip='single or comma separated'></i></label>
            <input type="text" v-model="pending_filters.searchID" placeholder="OC#" />


        </div>
        <div class="col-md-6 col-sm-12 col-filter-user" v-if="!hideUser">
            <label>User</label>
            <v-select label="display_name" :options="users"  @search="searchUsers" v-model="pending_filters.selectedUsers" multiple :filterable="false">
                <template slot="no-options">
                    Search for User(s)
                </template>
                <template slot="option" slot-scope="user">
                    {{ user.display_name }}
                </template>
            </v-select>
            <div v-if="!hideExcludeThirdParty">
                <div class="input-checkbox input-checkbox--switch input-checkbox--switch-small">
                    <input id="checkbox-switch-excludeThirdParty" type="checkbox" name="checkbox-switch-excludeThirdParty" v-model="pending_filters.excludeThirdParty" />
                    <label for="checkbox-switch-excludeThirdParty"></label>
                </div>
                <span>Exclude Submitted for Others</span>
            </div>
            <div v-if="!hideExcludeDotMap">
                <div class="input-checkbox input-checkbox--switch input-checkbox--switch-small">
                    <input id="checkbox-switch-excludeDM" type="checkbox" name="checkbox-switch-excludeDM" v-model="pending_filters.excludeDotMap" />
                    <label for="checkbox-switch-excludeDM"></label>
                </div>
                <span>Exclude Dot Map Project Results</span>
            </div>
            <div v-if="!hideExcludeiNat">
                <div class="input-checkbox input-checkbox--switch input-checkbox--switch-small">
                    <input id="checkbox-switch-excludeIN" type="checkbox" name="checkbox-switch-excludeIN" v-model="pending_filters.excludeiNat" />
                    <label for="checkbox-switch-excludeIN"></label>
                </div>
                <span>Exclude iNaturalist Results <i class="fa fa-info-circle" data-tooltip-wrap data-tooltip='iNaturalist locations of many "sensitive" species are obscured and coordinates are approximate (with 0.2 degrees lat-long).  Please remember many iNaturalist locations are only approximate.'></i></span>
            </div>
        </div>
        <div class="col-md-6 col-sm-12 col-filter-observer-confidence" v-if="!hideObserverConfiendce && force_show_filters([filters.selectedConfidences, filters.certifiedOnly])">
            <label>Observer ID Confidence</label>
            <v-select label="name" :options="confidenceLevels" v-model="pending_filters.selectedConfidences" multiple></v-select>
            <div v-if="!hideCertifiedOnly">
                <div class="input-checkbox input-checkbox--switch  input-checkbox--switch-small">
                    <input id="checkbox-switch-certified" type="checkbox" name="checkbox-switch-certified" v-model="pending_filters.certifiedOnly" />
                    <label for="checkbox-switch-certified"></label>
                </div>
                <span>Certified Observers Only</span>
            </div>
        </div>
        <div class="col-md-6 col-sm-12 col-filter-vetter" v-if="!hideVetter && force_show_filters([filters.selectedVetters])">
            <label>Vetter</label>
            <v-select label="display_name" :options="users"  @search="searchUsers" v-model="pending_filters.selectedVetters" multiple :filterable="false">
                <template slot="no-options">
                    Search for Vetter(s)
                </template>
                <template slot="option" slot-scope="user">
                    {{ user.display_name }}
                </template>
            </v-select>
        </div>
        <div class="col-sm-12 col-filter-daterange" v-if="!hideDateRange && force_show_filters([filters.startDate, filters.endDate])">
            <label>Date Range</label>
            <div class="row">
                <div class="col-md-6 col-sm-12">
                    <datepicker :clear-button="true" initial-view="year" placeholder="Start Date" v-model="pending_filters.startDate"></datepicker>
                </div>
                <div class="col-md-6 col-sm-12">
                    <datepicker :clear-button="true" initial-view="year" placeholder="End Date" v-model="pending_filters.endDate"></datepicker>
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-filter-monthrange" v-if="!hideMonthRange && force_show_filters([filters.startMonth, filters.endMonth])">
            <label>Month Range</label>
            <div class="row">
                <div class="col-md-6 col-sm-12">
                    <datepicker :clear-button="true" placeholder="Start Month" minimum-view="month" maximum-view="month" format="MMMM" v-model="pending_filters.startMonth"></datepicker>
                </div>
                <div class="col-md-6 col-sm-12">
                    <datepicker :clear-button="true" placeholder="End Month" minimum-view="month" maximum-view="month" format="MMMM" v-model="pending_filters.endMonth"></datepicker>
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-vetting-range" v-if="!hideVettingRange && force_show_filters([filters.startVetDate, filters.endVetDate])">
            <label>Vetting Date</label>
            <div class="row">
                <div class="col-md-6 col-sm-12">
                    <datepicker :clear-button="true" placeholder="Start Vetting Date" v-model="pending_filters.startVetDate"></datepicker>
                </div>
                <div class="col-md-6 col-sm-12">
                    <datepicker :clear-button="true" placeholder="End Vetting Date" v-model="pending_filters.endVetDate"></datepicker>
                </div>
            </div>
        </div>
        <div class="col-md-6 col-sm-12 col-filter-life-stage" v-if="!hideLifeStage && force_show_filters([filters.selectedLifeStages])">
            <label>Life Stage</label>
            <v-select label="name" :options="lifeStages" v-model="pending_filters.selectedLifeStages" multiple></v-select>
        </div>
        <div class="col-md-6 col-sm-12 col-filter-search" v-if="!hideSearch && force_show_search()">
            <label>Text to Search For</label>
            <input type="text" v-model="pending_filters.search" />
            <div v-show="pending_filters.search && pending_filters.search.length > 0">
                Search Fields:<br />
                <div>
                    <div class="input-checkbox input-checkbox--switch input-checkbox--switch-small">
                        <input id="search_fields_notes" type="checkbox" name="search_fields_notes"  v-model="pending_filters.search_fields.notes" />
                        <label for="search_fields_notes"></label>
                    </div>
                    <span>Specimen Notes</span>
                </div>
                <div>
                    <div class="input-checkbox input-checkbox--switch input-checkbox--switch-small">
                        <input id="search_fields_vetter_notes" type="checkbox" name="search_fields_vetter_notes"  v-model="pending_filters.search_fields.vetter_notes" />
                        <label for="search_fields_vetter_notes"></label>
                    </div>
                    <span>Decision Notes</span>
                </div>
                <div>
                    <div class="input-checkbox input-checkbox--switch input-checkbox--switch-small">
                        <input id="search_fields_location_name" type="checkbox" name="search_fields_location_name"  v-model="pending_filters.search_fields.location_name" />
                        <label for="search_fields_location_name"></label>
                    </div>
                    <span>Location Name</span>
                </div>
                <div>
                    <div class="input-checkbox input-checkbox--switch input-checkbox--switch-small">
                        <input id="search_fields_location_notes" type="checkbox" name="search_fields_location_notes"  v-model="pending_filters.search_fields.location_notes" />
                        <label for="search_fields_location_notes"></label>
                    </div>
                    <span>Location Notes</span>
                </div>
                <div>
                    <div class="input-checkbox input-checkbox--switch input-checkbox--switch-small">
                        <input id="search_fields_institution" type="checkbox" name="search_fields_institution"  v-model="pending_filters.search_fields.institution" />
                        <label for="search_fields_institution"></label>
                    </div>
                    <span>Institution</span>
                </div>
            </div>
        </div>
        <div class="col-md-6 col-sm-12 col-filter-project" v-if="!hideProject && force_show_filters([filters.selectedProjects])">
            <label>Project</label>
            <v-select label="name" :options="projects" v-model="pending_filters.selectedProjects" multiple></v-select>
        </div>
        <div class="col-md-6 col-sm-12 col-filter-import" v-if="userCanVet() && !hideImport && force_show_filters([filters.selectedImports])">
            <label>Import</label>
            <v-select label="name" :options="imports" v-model="pending_filters.selectedImports" multiple></v-select>
        </div>
        <div class="col-12 col-more-filters text-center">
            <button v-if="!user_show_all" class="btn btn--xs" @click="user_show_all=true;">more filters</button>
            <button class="btn btn-primary btn-block" @click="applyFilters">Apply Filtering</button>
        </div>
        <div class="modal-container" id="iNatWarningModal">
            <div class="modal-content section-modal">
                <section class="unpad ">
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-12">
                                <div class="feature feature-1 text-center">
                                    <div class="alert alert-warning">
                                        <a class="btn pull-right btn-sm" onclick="mr.modals.closeActiveModal();">X</a>
                                        <strong>Reminder:</strong>  Many iNaturalist locations are only approximate. iNaturalist locations of many species considered “sensitive” are obscured automatically by iNaturalist.  They are assigned random coordinates within 0.2 degrees of the actual location.   iNaturalist renders these observations at these random coordinates and so does Odonata Central.   See FAQ for more information.
                                    </div>
                                </div>
                                <!--end feature-->
                            </div>
                        </div>
                        <!--end of row-->
                    </div>
                    <!--end of container-->
                </section>
            </div>
        </div>
    </div>
</template>

<script>
    import global_data from '../main';
    import axios from 'axios';
    export default {
        name: 'SightingFilters',
        props: [
            'filterqs',
            'apiBaseSightings',
            'apiBaseChecklists',
            'hideVetting',
            'hideUser',
            'hideStatus',
            'hideRecordType',
            'hideObserverConfiendce',
            'hideObserverStatus',
            'hideTaxon',
            'hideLocation',
            'hideDateRange',
            'hideID',
            'hideMonthRange',
            'hideVetter',
            'hideVettingRange',
            'hide',
            'hideExcludeDotMap',
            'hideExcludeThirdParty',
            'hideCertifiedOnly',
            'hideHighQualityOnly',
            'hideIncludeDeclined',
            'hideLifeStage',
            'hideProject',
            'hideImport',
            'hideSearch',
            'hideExcludeiNat',
            'currentUser',
            'disableDefaultExcludeDotMap',
        ],
        data: function(){
            return {
                api_base_sightings: this.apiBaseSightings,
                api_base_checklists: this.apiBaseChecklists,
                users: [],
                all_statuses: [],
                statuses: [],
                lifeStages: [],
                projects: [],
                imports: [],
                recordTypes: [],
                confidenceLevels: [],
                locations: [],
                taxa: [],
                pending_promises: 0,
                filters: this.getDefaultFilters(false),
                pending_filters: this.getDefaultFilters(false),
                user_show_all: false,
                waiting: false,
            };
        },
        computed: {
        },
        created:function(){
            var self = this;

            if (this.hideExcludeiNat) {
                this.filters.excludeiNat = false;
                this.pending_filters.excludeiNat = false;
            }

            if (!this.$route.query.filterqs) {
                self.$emit('filtersLoaded');
                return;
            }

            var qs = this.$route.query.filterqs.split("|");
            var allPromises = [];
            for (var j = 0; j < qs.length; j++) {
                var q = qs[j];
                if (q == "") {continue;}
                var qa = q.split(":");
                if (qa.length == 1) {
                    var single_param = qa[0];
                    switch(single_param) {
                        case "excludedotmap":
                            self.filters.excludeDotMap = true;
                            break;
                        case "excludeinat":
                            self.filters.excludeiNat = true;
                            break;
                        case "excludethirdparty":
                            self.filters.excludeThirdParty = true;
                            break;
                        case "certifiedonly":
                            self.filters.certifiedOnly = true;
                            break;
                        case "highqualityonly":
                            self.filters.highQualityOnly = true;
                            break;
                        case "includedeclined":
                            self.filters.includeDeclined = true;
                            break;
                        case "vettableonly":
                            self.filters.vettableOnly = true;
                            break;
                        case "pendingonly":
                            self.filters.pendingOnly = true;
                            break;
                        case "outliersonly":
                            self.filters.outliersOnly = true;
                            break;
                    }
                }

                if (qa.length != 2) {continue;}

                var param = qa[0];
                var values = qa[1];
                switch(param) {
                    case "id":
                        self.filters.searchID = values;
                        break;
                    case "users":
                        allPromises.push(self.getMultiSelected(values, 'users/', 'selectedUsers', 'user'));
                        break;
                    case "vetters":
                        allPromises.push(self.getMultiSelected(values, 'users/', 'selectedVetters', 'user'));
                        break;
                    case "statuses":
                        allPromises.push(self.getMultiSelected(values, 'sighting-statuses/', 'selectedStatuses', 'sighting_status'));
                        break;
                    case "lifestages":
                        allPromises.push(self.getMultiSelected(values, 'life-stages/', 'selectedLifeStages', 'life_stage'));
                        break;
                    case "projects":
                        allPromises.push(self.getMultiSelected(values, 'projects/', 'selectedProjects', 'project'));
                        break;
                    case "imports":
                        allPromises.push(self.getMultiSelected(values, 'imports/', 'selectedImports', 'import'));
                        break;
                    case "recordTypes":
                        allPromises.push(self.getMultiSelected(values, 'sighting-types/', 'selectedRecordTypes', 'sighting_type'));
                        break;
                    case "confidences":
                        allPromises.push(self.getMultiSelected(values, 'id-confidences/', 'selectedConfidences', 'id_confidence'));
                        break;
                    case "taxons":
                        allPromises.push(self.getMultiSelected(values, 'taxa/', "selectedTaxons", 'taxon'));
                        break;
                    case "locations":
                        allPromises.push(self.getMultiSelected(values, 'locations/', 'selectedLocations', 'location'));
                        break;
                    case "startDate":
                        self.filters.startDate = new Date(parseInt(values));
                        break;
                    case "endDate":
                        self.filters.endDate = new Date(parseInt(values));
                        break;
                    case "startVetDate":
                        self.filters.startVetDate = new Date(parseInt(values));
                        break;
                    case "endVetDate":
                        self.filters.endVetDate = new Date(parseInt(values));
                        break;
                    case "startMonth":
                        self.filters.startMonth = new Date(parseInt(values));
                        break;
                    case "endMonth":
                        self.filters.endMonth = new Date(parseInt(values));
                        break;
                    case "id":
                        this.filters.searchID = parseInt(values);
                        break;
                    case "search":
                        this.filters.search = values;
                    case "searchFields":
                        var split = values.split("-");
                        this.filters.search_fields.notes = split.includes("notes");
                        this.filters.search_fields.vetter_notes = split.includes("vetter_notes");
                        this.filters.search_fields.location_name = split.includes("location_name");
                        this.filters.search_fields.location_notes = split.includes("location_notes");
                        this.filters.search_fields.institution = split.includes("institution");
                }
            }
            if (allPromises.length > 0) {
                axios.all(allPromises);
            }
            else{
                self.$emit('filtersLoaded');
            }
        },
        methods:{
            getDefaultFilters(forceTrueDefaults){
                var trueDefaults = forceTrueDefaults || typeof this.$route.query.filterqs == 'undefined';
                return {
                    selectedUsers: null,
                    selectedStatuses: null,
                    selectedRecordTypes: null,
                    selectedConfidences: null,
                    selectedTaxons: null,
                    selectedLocations: null,
                    selectedLifeStages: null,
                    selectedProjects: null,
                    selectedImports: null,
                    searchID: null,
                    startDate:null,
                    endDate:null,
                    startMonth:null,
                    endMonth:null,
                    excludeDotMap:(trueDefaults && !this.disableDefaultExcludeDotMap),
                    excludeiNat: (trueDefaults),
                    excludeThirdParty: null,
                    highQualityOnly:null,
                    includeDeclined:null,
                    certifiedOnly:null,
                    selectedVetters:null,
                    startVetDate:null,
                    endVetDate:null,
                    vettableOnly:null,
                    pendingOnly:null,
                    outliersOnly:null,
                    search:null,
                    search_fields: {
                        notes: true,
                        vetter_notes: true,
                        location_name: true,
                        location_notes:true,
                        institution:true,
                    }
                }
            },
            showiNatWarningModal(){
                if (this.$cookie.get('iNatWarningShown') == null) {
                    mr.modals.showModal($('#iNatWarningModal'));
                    this.$cookie.set('iNatWarningShown', true, 1);
                }
            },
            getActiveStatuses:function(){
                if (this.filters.includeDeclined || this.pending_filters.includeDeclined) {
                    return this.all_statuses;
                }
                var ret = []
                for (var i = 0; i < this.all_statuses.length; i++) {
                    if (this.all_statuses[i].name != "Declined") {
                        ret.push(this.all_statuses[i])
                    }
                }
                return ret;
            },
            userCanVet:function(){
                return this.currentUser &&  this.currentUser.profile.vetter;
            },
            getMultiSelected:function(values, endpoint, target_variable_name, targt_data_name){
                this.waiting = true;
                var self = this;
                var ids = values.split(',');
                var promises = [];
                for (var i = 0; i < ids.length; i++) {
                    this.pending_promises += 1;
                    promises.push(self.API({
                        endpoint: endpoint + ids[i],
                        funcThen: function(response){
                            if (self.filters[target_variable_name] == null) {
                                self.filters[target_variable_name] = [];
                            }
                            self.filters[target_variable_name].push(response.data[targt_data_name]);
                        },
                        funcAfterThen:function(){
                            self.pending_promises -= 1;
                            if (self.pending_promises == 0) {
                                self.waiting = false;
                                self.filterChanged(false);
                                self.$emit('filtersLoaded');
                            }
                        },
                    }));
                }
                return promises;
            },
            force_show_filters:function(filters_array){
                for (var i = 0; i < filters_array.length; i++) {
                    if (filters_array[i] != null) {
                        return true;
                    }
                }
                return this.user_show_all;
            },
            force_show_search:function(){
                return this.user_show_all || this.search && this.search.trim() != "";
            },
            searchUsers: function(search, loading){
                loading(true);
                var target = this;

                this.API({
                    endpoint: 'users',
                    querystring: "&search="+search,
                    funcThen: function(response){
                        target.users = response.data.users;
                    },
                    funcAfterThen: function(){
                        loading(false);
                    }
                });
            },
            searchLocations: function(search, loading){
                loading(true);
                var target = this;

                this.API({
                    endpoint: 'locations',
                    querystring: "&include[]=type.*&search="+search,
                    funcThen: function(response){
                        for (var i = 0; i < response.data.locations.length; i++) {
                            response.data.locations[i].type_data = response.data.location_types.find(l => l.id == response.data.locations[i].type)
                        }
                        target.locations = response.data.locations;
                    },
                    funcAfterThen: function(){
                        loading(false);
                    }
                });
            },
            searchTaxa: function(search, loading){
                if (!search || search.length < 3) {
                    return;
                }
                loading(true);
                var target = this;

                this.API({
                    endpoint: 'taxa',
                    querystring: "&search="+search,
                    funcThen: function(response){
                        target.taxa = response.data.taxa;
                    },
                    funcAfterThen: function(){
                        loading(false);
                    }
                });
            },
            pendingFilterChanged(){
                this.statuses = this.getActiveStatuses();
            },
            filterChanged: function(by_user_action){
                if (this.waiting) {
                    return;
                }
                this.statuses = this.getActiveStatuses();

                var defaultQuery = this.buildDefaultQuery();

                let query = Object.assign({}, this.$route.query);
                query.filterqs = this.getEncodedQueryString();
                this.$router.replace({query: query});


                this.$emit('filterChanged', this.filters, defaultQuery, by_user_action);
            },
            getMultiQSPart: function(key, selected){
                var b = "";
                if (selected != null && selected.length > 0) {
                    b += "|"+key+":"
                    for (var i = 0; i < selected.length; i++) {
                        if (i != 0) { b += ",";}
                        b += selected[i].id;
                    }
                    return b;
                }
                return "";
            },
            getEncodedQueryString: function (){
                var qs = "";
                if (this.filters.excludeDotMap) {
                    qs +="|excludedotmap"
                }
                if (this.filters.excludeiNat) {
                    qs +="|excludeinat"
                }
                if (this.filters.excludeThirdParty) {
                    qs +="|excludethirdparty"
                }
                if (this.filters.certifiedOnly) {
                    qs +="|certifiedonly"
                }
                if (this.filters.highQualityOnly) {
                    qs +="|highqualityonly"
                }
                if (this.filters.includeDeclined) {
                    qs +="|includedeclined"
                }
                if (this.filters.vettableOnly && this.userCanVet()) {
                    qs +="|vettableonly"
                }
                if (this.filters.pendingOnly && this.userCanVet()) {
                    qs +="|pendingonly"
                }
                if (this.filters.outliersOnly && this.userCanVet()) {
                    qs +="|outliersonly"
                }
                if (this.filters.startDate != null) {
                    qs += "|startDate:" + this.filters.startDate.getTime();
                }
                if (this.filters.endDate != null) {
                    qs += "|endDate: " + this.filters.endDate.getTime();
                }
                if (this.filters.startVetDate != null) {
                    qs += "|startVetDate:" + this.filters.startVetDate.getTime();
                }
                if (this.filters.endVetDate != null) {
                    qs += "|endVetDate: " + this.filters.endVetDate.getTime();
                }
                if (this.filters.startMonth != null || this.filters.endMonth != null) {
                    var startMonthDate = this.filters.startMonth;
                    var endMonthDate = this.filters.endMonth;
                    if (endMonthDate == null) {
                        endMonthDate = startMonthDate;
                    }
                    if (startMonthDate == null) {
                        startMonthDate = endMonthDate;
                    }

                    qs += "|startMonth:"+ (startMonthDate.getTime());
                    qs += "|endMonth:" + (endMonthDate.getTime());
                }
                if (this.filters.searchID != null && this.filters.searchID != "") {
                    qs += "|id:"+ this.filters.searchID;
                }
                qs += this.getMultiQSPart('users', this.filters.selectedUsers);
                qs += this.getMultiQSPart('vetters', this.filters.selectedVetters);
                if (!(this.filters.pendingOnly && this.userCanVet())) {
                    qs += this.getMultiQSPart('statuses', this.filters.selectedStatuses);
                }
                qs += this.getMultiQSPart('lifestages', this.filters.selectedLifeStages);
                qs += this.getMultiQSPart('projects', this.filters.selectedProjects);
                qs += this.getMultiQSPart('imports', this.filters.selectedImports);
                qs += this.getMultiQSPart('recordTypes', this.filters.selectedRecordTypes);
                qs += this.getMultiQSPart('confidences', this.filters.selectedConfidences);
                qs += this.getMultiQSPart('taxons', this.filters.selectedTaxons);
                qs += this.getMultiQSPart('locations', this.filters.selectedLocations);
                if (this.filters.search && this.filters.search.trim() != "") {
                    qs += "|search:" + this.filters.search.trim();
                    qs += "|searchFields:";
                    if(this.filters.search_fields.notes){
                        qs += "-notes";
                    }
                    if(this.filters.search_fields.vetter_notes){
                        qs += "-vetter_notes";
                    }
                    if(this.filters.search_fields.location_name){
                        qs += "-location_name";
                    }
                    if(this.filters.search_fields.location_notes){
                        qs += "-location_notes";
                    }
                    if(this.filters.search_fields.institution){
                        qs += "-institution";
                    }
                }
                return qs;
            },
            buildMutliQueryPart: function(selections, filter_key){
                if (selections != null) {
                    var filter_string = "";
                    for (var i = 0; i < selections.length; i++) {
                        filter_string += "&filter{"+this.get_sighting_api_base()+filter_key+"}=" + selections[i].id;
                    }
                    return filter_string;
                }
                return "";
            },
            get_sighting_api_base: function(){
                if (typeof this.api_base_sightings !== undefined && this.api_base_sightings) {
                    if (this.api_base_sightings == "empty") {
                        return "";
                    }
                    return this.api_base_sightings;
                }
                return '';
            },
            get_checklist_api_base:function(){

                if (typeof this.api_base_checklists !== undefined && this.api_base_checklists) {
                    if (this.api_base_checklists == "empty") {
                        return "";
                    }
                    return this.api_base_checklists;
                }
                return this.get_sighting_api_base() + "checklist.";
            },
            buildDefaultQuery: function(){
                var filter_string = "";
                filter_string += this.buildMutliQueryPart(this.filters.selectedUsers, "checklist.user.id.in");
                filter_string += this.buildMutliQueryPart(this.filters.selectedVetters, "vetter.in");
                if (!(this.filters.pendingOnly && this.userCanVet())) {
                    filter_string += this.buildMutliQueryPart(this.filters.selectedStatuses, "status.in");
                }
                filter_string += this.buildMutliQueryPart(this.filters.selectedLifeStages, "life_stage.in");
                filter_string += this.buildMutliQueryPart(this.filters.selectedProjects, "checklist.projects.in");

                filter_string += this.buildMutliQueryPart(this.filters.selectedImports, "checklist.import.in");

                filter_string += this.buildMutliQueryPart(this.filters.selectedRecordTypes, "type.in");
                filter_string += this.buildMutliQueryPart(this.filters.selectedConfidences, "observer_confidence.in");
                filter_string += this.buildMutliQueryPart(this.filters.selectedTaxons, "taxon.in");
                filter_string += this.buildMutliQueryPart(this.filters.selectedLocations, "checklist.location.in");
                if (this.filters.excludeDotMap) {
                    filter_string += "&filter{-"+this.get_checklist_api_base()+"user.username.in}=Dot_Map_Project";
                }
                if (this.filters.excludeiNat) {
                    filter_string += "&filter{-"+this.get_checklist_api_base()+"user.username.in}=iNaturalist";
                }
                if (this.filters.excludeThirdParty) {
                    filter_string += "&filter{"+this.get_checklist_api_base()+"observer.isnull}=1";
                }
                if (this.filters.certifiedOnly) {
                    filter_string += "&filter{"+this.get_checklist_api_base()+"certified_observer}=true";
                }
                if (this.filters.highQualityOnly) {
                    filter_string += "&filter{quality}=high";
                }
                if (this.filters.includeDeclined) {
                    filter_string += "&include_declined=true";
                }
                if (this.filters.vettableOnly && this.userCanVet()) {
                    filter_string += "&filter{can_vet}=true";
                }
                if (this.filters.pendingOnly && this.userCanVet()) {
                    filter_string += "&filter{"+this.get_sighting_api_base()+"status.in}=3";
                }
                if (this.filters.outliersOnly && this.userCanVet()) {
                    filter_string += "&filter{"+this.get_sighting_api_base()+"outlier}=1";
                }
                if (this.filters.startDate != null) {
                    filter_string += "&filter{"+this.get_checklist_api_base()+"datetime.gte}=" + this.formatDate(this.filters.startDate);
                }
                if (this.filters.endDate != null) {
                    filter_string += "&filter{"+this.get_checklist_api_base()+"datetime.lte}=" + this.formatDate(this.filters.endDate);
                }
                if (this.filters.startVetDate != null) {
                    filter_string += "&filter{"+this.get_sighting_api_base()+"vetted_datetime.gte}=" + this.formatDate(this.filters.startVetDate);
                }
                if (this.filters.endVetDate != null) {
                    filter_string += "&filter{"+this.get_sighting_api_base()+"vetted_datetime.lte}=" + this.formatDate(this.filters.endVetDate);
                }
                if (this.filters.startMonth != null || this.filters.endMonth != null) {
                    var startMonthDate = this.filters.startMonth;
                    var endMonthDate = this.filters.endMonth;
                    if (endMonthDate == null) {
                        endMonthDate = startMonthDate;
                    }
                    if (startMonthDate == null) {
                        startMonthDate = endMonthDate;
                    }
                    filter_string += "&filter{"+this.get_checklist_api_base()+"datetime.month.range}="+ (startMonthDate.getMonth() + 1) +"&filter{"+this.get_checklist_api_base()+"datetime.month.range}=" +  (endMonthDate.getMonth() + 1);
                }
                if (this.filters.searchID != null && this.filters.searchID != "") {
                    if (this.filters.searchID.indexOf(',') == -1) {
                        filter_string += "&filter{"+this.get_sighting_api_base()+"id}=" + this.filters.searchID;
                    }
                    else{
                        var sidstrings = this.filters.searchID.split(',');
                        var sid, sidstring;
                        for (var i = 0; i < sidstrings.length; i++) {
                            sidstring = sidstrings[i];
                            sid = parseInt(sidstring);
                            if (!isNaN(sid)) {
                                filter_string += "&filter{"+this.get_sighting_api_base()+"id.in}=" + sid;
                            }
                        }
                    }
                }
                if (this.filters.search && this.filters.search.trim() != "") {
                    filter_string += "&search=" + this.filters.search;
                    if(this.filters.search_fields.notes){
                        filter_string += "&search_fields[]="+this.get_sighting_api_base()+"notes";
                    }
                    if(this.filters.search_fields.vetter_notes){
                        filter_string += "&search_fields[]="+this.get_sighting_api_base()+"vetter_notes";
                    }
                    if(this.filters.search_fields.location_name){
                        filter_string += "&search_fields[]="+this.get_checklist_api_base()+"location.display_name";
                    }
                    if(this.filters.search_fields.location_notes){
                        filter_string += "&search_fields[]="+this.get_checklist_api_base()+"location.notes";
                    }
                    if(this.filters.search_fields.institution){
                        filter_string += "&search_fields[]="+this.get_sighting_api_base()+"institution";
                    }
                }
                return filter_string;
            },
            getMultiOptions:function(endpoint, option_name, result_name){
                var self = this;
                this.API({
                    endpoint: endpoint,
                    funcThen: function(response){
                        self[option_name] = response.data[result_name];
                        if (option_name == 'all_statuses') {
                            self.statuses = self.getActiveStatuses();
                        }
                    }
                });
            },
            resetFilters:function(){
                this.pending_filters = this.getDefaultFilters(true);
            },
            applyFilters:function(){
                this.filters = this.pending_filters;
                this.filterChanged(true);
            },
        },
        mounted(){
            var waiting = this.getMultiOptions('sighting-statuses', 'all_statuses', 'sighting_statuses');
            waiting = waiting || this.getMultiOptions('sighting-types', 'recordTypes', 'sighting_types');
            waiting = waiting || this.getMultiOptions('id-confidences', 'confidenceLevels', 'id_confidences');
            waiting = waiting || this.getMultiOptions('life-stages', 'lifeStages', 'life_stages');
            waiting = waiting || this.getMultiOptions('projects', 'projects', 'projects');
            waiting = waiting || this.getMultiOptions('imports', 'imports', 'imports');

            if (!waiting) {
                this.filterChanged(false);
            }
        },
        watch:{
            filters: {
                handler(val){
                    this.pending_filters = this.filters;
                    // this.filterChanged(true);
                },
                deep: true
            },
            pending_filters: {
                handler(val, oldval){
                    this.pendingFilterChanged();
                    this.$emit('pendingFilterChanged', this.pending_filters);
                },
                deep: true
            },
            'pending_filters.excludeiNat':{
                handler(val, oldval){
                    if (!this.hideExcludeiNat && !val && oldval) {
                        this.showiNatWarningModal();
                    }
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/SightingFilters.vue